export enum FormTemplateMode {
  Add = 'add',
  Edit = 'edit',
  EditVersion = 'editVersion',
  View = 'view',
  ViewLinkedDocuments = 'viewLinkedDocuments',
  ViewLinkedTasks = 'viewLinkedTasks',
  Duplicate = 'duplicate',
}
